import ManageMySpending from "../ManageMySpending";
import { Button2, Checkbox, Radio, Select, ToggleButton } from "../../index";
import plusIcon from "../../../assets/icons/plus.png";
import listIcon from "../../../assets/icons/list-icon.png";
import calendarIcon from "../../../assets/icons/calendar-icon.png";
import {
  NoteIcon,
  BuildingIcon,
  ShoppingCartIcon,
  GraduationHatIcon,
  PetIcon,
  CreditCardIcon,
  WavyNoteIcon,
  PlaneIcon,
  HeartHandIcon,
  GiftIcon,
  GamingPadIcon,
  MedicalCrossIcon,
} from "../../svg-organizer/SvgOrganizer";
import { useBills } from "../../../data/live";
import { useState } from "react";
import { DatePicker, Input, Modal, Switch } from "antd";
import uploadIcon from "../../../assets/icons/upload-icon.png";
import QuickActionSelect from "../../quick-action-select/QuickActionSelect";

const MyBills = () => {
  const { source } = useBills();
  const [openModal, setOpenModal] = useState(false);
  const [showAdvanced, setShowAdvanced] = useState(false);
  const filterData = [
    {
      filtername: "Budgeted",
      filterInfo: "10% Remain",
      filter: [
        {
          checkbox: {
            color: "white",
            colorTick: "#1bbb6b",
            check: true,
          },
          icon: <NoteIcon color="white" />,
          name: "Income",
          amount: "$4,000",
          backgroundColor: "#1bbb6b",
        },
      ],
      total: "Total Income",
      totalAmount: "$4,000",
    },
    {
      filtername: "Actual",
      filterInfo: "10% Remain",
      filter: [
        {
          checkbox: {
            color: "white",
            colorTick: "#1bbb6b",
            check: true,
          },
          icon: <NoteIcon color="white" />,
          name: "Income",
          amount: "$4,000",
          backgroundColor: "#1bbb6b",
        },
      ],
      total: "Total Income",
      totalAmount: "$4,000",
    },
    {
      filtername: "Expense",
      filterInfo: "10% Remain",

      filter: [
        {
          checkbox: {
            color: "#1bbb6b",
            colorTick: "white",
            check: true,
          },
          icon: <BuildingIcon />,
          name: "Rent",
          amount: "$4,000",
          backgroundColor: "#E8550D",
        },
        {
          checkbox: {
            color: "#1bbb6b",
            colorTick: "white",
            check: true,
          },
          icon: <ShoppingCartIcon />,
          name: "Groceries",
          amount: "$458",
          backgroundColor: "#F2E103",
        },
        {
          checkbox: {
            color: "#1bbb6b",
            colorTick: "white",
            check: false,
          },
          icon: <GraduationHatIcon />,
          name: "Education & Training",
          amount: "$0",
          backgroundColor: "white",
        },
        {
          checkbox: {
            color: "#1bbb6b",
            colorTick: "white",
            check: false,
          },
          icon: <PetIcon />,
          name: "Pets",
          amount: "$0",
          backgroundColor: "white",
        },
        {
          checkbox: {
            color: "#1bbb6b",
            colorTick: "white",
            check: false,
          },
          icon: <CreditCardIcon />,
          name: "Others & ATM",
          amount: "$0",
          backgroundColor: "white",
        },
        {
          checkbox: {
            color: "#1bbb6b",
            colorTick: "white",
            check: false,
          },
          icon: <WavyNoteIcon />,
          name: "Mortgage & Loans",
          amount: "$0",
          backgroundColor: "white",
        },
        {
          checkbox: {
            color: "#1bbb6b",
            colorTick: "white",
            check: false,
          },
          icon: <PlaneIcon />,
          name: "Travel",
          amount: "$0",
          backgroundColor: "white",
        },
        {
          checkbox: {
            color: "#1bbb6b",
            colorTick: "white",
            check: false,
          },
          icon: <HeartHandIcon />,
          name: "Personal Care",
          amount: "$0",
          backgroundColor: "white",
        },
        {
          checkbox: {
            color: "#1bbb6b",
            colorTick: "white",
            check: true,
          },
          icon: <GiftIcon />,
          name: "Gift & Donation",
          amount: "$168",
          backgroundColor: "#2660CE",
        },
        {
          checkbox: {
            color: "#1bbb6b",
            colorTick: "white",
            check: false,
          },
          icon: <GamingPadIcon />,
          name: "Hobbies & Entertainment",
          amount: "$0",
          backgroundColor: "white",
        },
        {
          checkbox: {
            color: "#1bbb6b",
            colorTick: "white",
            check: false,
          },
          icon: <MedicalCrossIcon />,
          name: "Health",
          amount: "$0",
          backgroundColor: "white",
        },
      ],
      total: "Total Expenses",
      totalAmount: "$4,000",
    },
  ];
  return (
    <>
      {/* Modal for New Transaction */}
      <Modal
        title={<p className="fs-5 fw-semibold">Create New Transaction</p>}
        centered
        width={600}
        open={openModal}
        onCancel={() => setOpenModal(false)}
        onOk={() => setOpenModal(false)}
        okText={"Save"}
        okButtonProps={{ className: "bg-black text-white rounded-pill" }}
        cancelButtonProps={{
          className: "rounded-pill",
          style: { borderColor: "#E7040C ", color: "#E7040C" },
        }}
      >
        <div className="d-flex align-items-center justify-content-between mb-3">
          <span className="fs12px fw-medium" style={{ color: "#7D7D7D" }}>
            Advanced view
          </span>
          <Switch checked={showAdvanced} onChange={setShowAdvanced} />
        </div>

        {showAdvanced ? (
          <div className="d-flex flex-column gap-3 ">
            <div className="d-flex flex-column gap-2">
              <label className="fs12px">Title</label>
              <Input className="p-3" placeholder="Input title" />
            </div>

            <div className="d-flex gap-3 align-items-center">
              <div className="d-flex flex-column gap-2 w-50">
                <label className="fs12px">Transaction</label>
                <DatePicker
                  className="p-3"
                  placeholder="Select Date"
                  suffixIcon={<img src={calendarIcon} alt="calendar" />}
                />
              </div>
              <div className="d-flex flex-column gap-2 w-auto">
                <label className="fs12px">Transaction Type</label>
                <div className="d-flex align-items-center gap-2 flex-wrap">
                  <div className="d-flex gap-1 align-items-center pe-2">
                    <Radio
                      height={"22px"}
                      width={"22px"}
                      accentColor={"green"}
                      name={"transaction-type"}
                      value="deposit"
                    />
                    <label className="fs14px">Deposit</label>
                  </div>
                  <div className="d-flex gap-1 align-items-center">
                    <Radio
                      height={"22px"}
                      width={"22px"}
                      accentColor={"green"}
                      name={"transaction-type"}
                      value="withdrawal"
                    />
                    <label className="fs14px">Withdrawal</label>
                  </div>
                  <div className="d-flex gap-1 align-items-center">
                    <Radio
                      height={"22px"}
                      width={"22px"}
                      accentColor={"green"}
                      name={"transaction-type"}
                      value="transfer"
                    />
                    <label className="fs14px">Transfer</label>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex gap-3 align-items-center">
              <div className="d-flex flex-column gap-2 w-100">
                <label className="fs12px">Amount</label>
                <Input className="p-3" placeholder="Input amount" />
              </div>
              <div className="d-flex flex-column gap-2 w-auto">
                <label className="fs12px">Currency</label>
                <Select defaultValue="AUD" className="p-3" />
              </div>
            </div>

            <div className="d-flex flex-column gap-2 ">
              <label className="fs12px">Transferred from account</label>
              <Select defaultValue="Saving Account" className="p-3" />
            </div>

            <div className="d-flex gap-3 align-items-center">
              <div className="d-flex flex-column gap-2 w-50">
                <label className="fs12px">Transfer to account</label>
                <Select defaultValue="Checking" className="p-3" />
              </div>
              <div className="d-flex flex-column gap-2 w-50">
                <label className="fs12px">Category</label>
                <Select defaultValue="Unassigned" className="p-3" />
              </div>
            </div>

            <div className="d-flex gap-3 align-items-center">
              <div className="d-flex flex-column gap-2 w-50">
                <label className="fs12px">Attach image</label>
                <Input
                  className="p-3"
                  value="savannahava.jpg"
                  suffix={
                    <img
                      src={uploadIcon}
                      alt="upload"
                      className="cursor-pointer"
                    />
                  }
                />
              </div>
              <div className="d-flex flex-column gap-2 w-50">
                <label className="fs12px">Add notes</label>
                <Input className="p-3" placeholder="Input notes" />
              </div>
            </div>

            <div className="d-flex gap-3 align-items-center">
              <Checkbox className={"w-25"}>Repeat Every</Checkbox>
              <Select
                className="p-3 w-25"
                options={[
                  { name: "1", value: "1" },
                  { name: "2", value: "2" },
                  { name: "3", value: "3" },
                  { name: "4", value: "4" },
                ]}
              />

              <Select className="p-3 w-25" defaultValue="Month" />
              <Select className="p-3 w-25" defaultValue="Weekend" />
            </div>

            <div className="d-flex flex-column gap-2 ">
              <label className="fs12px">Repeat Starting</label>
              <div className="d-flex gap-3 align-items-center">
                <Select className="p-3 " defaultValue="4 April 2023" />

                <Select className="p-3 " defaultValue="Until" />
                <Select className="p-3 " defaultValue="18 April 2025" />
              </div>
            </div>

            <div className="d-flex gap-2 align-items-center">
              <Checkbox>Remind Me</Checkbox>
              <div className="d-flex  align-items-center">
                <span className="fs14px fw-semibold">Email me</span>
                <Select
                  className="w-auto border-0"
                  options={[
                    { name: "1", value: "1" },
                    { name: "2", value: "2" },
                    { name: "3", value: "3" },
                    { name: "4", value: "4" },
                  ]}
                  selectStyle={{ color: "#1bbb6b" }}
                />
                <span className="fs14px fw-semibold">days before.</span>
              </div>

              <Checkbox className={"ps-4"}>Mark as completed</Checkbox>
            </div>
          </div>
        ) : (
          <div className="d-flex flex-column gap-3 ">
            <div className="d-flex flex-column gap-2">
              <label className="fs12px">Category</label>
              <Select className="p-3" defaultValue="Choose Category" />
            </div>

            <div className="d-flex flex-column gap-2">
              <label className="fs12px">Customer/Bill Reference Number</label>
              <div className="d-flex gap-2 align-items-center">
                <div className="d-flex gap-2 align-items-center pe-2">
                  <Radio
                    height={"22px"}
                    width={"22px"}
                    accentColor={"green"}
                    name={"refrencen-number"}
                    value="everymonth"
                  />
                  <label className="fs14px">Every month</label>
                </div>
                <div className="d-flex gap-2 align-items-center pe-2">
                  <Radio
                    height={"22px"}
                    width={"22px"}
                    accentColor={"green"}
                    name={"refrencen-number"}
                    value="everyfewmonth"
                  />
                  <label className="fs14px">Every few month</label>
                </div>
                <div className="d-flex gap-2 align-items-center pe-2">
                  <Radio
                    height={"22px"}
                    width={"22px"}
                    accentColor={"green"}
                    name={"refrencen-number"}
                    value="once"
                  />
                  <label className="fs14px">Once</label>
                </div>
              </div>
              <Checkbox className={"fs12px"}>
                Start each new month with the previous month's leftover amount
              </Checkbox>
            </div>

            <div className="d-flex gap-3 align-items-center">
              <div className="d-flex flex-column gap-2 w-100">
                <label className="fs12px">Amount</label>
                <Input className="p-3" placeholder="Input amount" />
              </div>
              <div className="d-flex flex-column gap-2 w-auto">
                <label className="fs12px">Currency</label>
                <Select defaultValue="AUD" className="p-3" />
              </div>
            </div>

            <span className="fs12px fw-medium" style={{ color: "#7D7D7D" }}>
              We'll set a budget of $180 each month for{" "}
              <span className="text-black">Gas & Fuel</span> that starts over at
              the beginning of every month.
            </span>
          </div>
        )}
      </Modal>

      <ManageMySpending navName={"Manage My Spending"}>
        <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap flex-md-nowrap gap-2 gap-md-0">
          <div className="w-auto">
            <ToggleButton
              options={[
                "Checking: $4,050",
                "Saving Accounts: $2,000",
                "All Accounts",
              ]}
              block={true}
            />
          </div>

          <Checkbox>Show opening from previous period</Checkbox>
        </div>

        <div className="d-flex justify-content-md-between align-items-center mt-3 gap-2 gap-md-0 flex-wrap flex-md-nowrap justify-content-center">
          <div className="d-flex align-items-center gap-2">
            <span className="fs-5 fw-bold">My Income & Expense</span>
            {source === "api" && (
              <span className="badge rounded-pill bg-success-subtle text-success border border-success-subtle fs10px">
                LIVE
              </span>
            )}
          </div>
          <div className="d-flex gap-2 align-items-center w-auto flex-wrap justify-content-center">
            <Select
              defaultValue="Include"
              className="rounded-pill w-auto"
              options={[
                { name: "Budget", value: "budget" },
                { name: "Actual", value: "actual" },
                { name: "Both", value: "both" },
              ]}
            />
            <Button2
              buttonName={"New Transaction"}
              icon={<img src={plusIcon} alt="add" />}
              className={"btn-outline-success "}
              divClassName={"gap-1"}
              onClick={() => setOpenModal(true)}
            />
            <QuickActionSelect />
            <ToggleButton
              options={[
                { value: "List", icon: <img src={listIcon} alt="list" /> },
                {
                  value: "Calendar",
                  icon: <img src={calendarIcon} alt="calendar" />,
                },
              ]}
            />
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-lg-4">
            <div className="d-flex flex-column  rounded-3 border  h-100">
              <div className="d-flex justify-content-between align-items-center p-3 px-4">
                <span className="fs-5 fw-semibold">Filter</span>
                <span
                  className="fw-medium fs14px cursor-pointer"
                  style={{ color: "#1bbb6b" }}
                >
                  Reset
                </span>
              </div>
              {/* Filter */}
              {filterData.map(
                (
                  { filtername, filterInfo, filter, total, totalAmount },
                  key
                ) => (
                  <div className="d-flex flex-column gap-2 p-3 px-4 border-bottom">
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="fs14px fw-semibold">{filtername}</span>
                      <span className="fw-semibold fs14px cursor-pointer">
                        {filterInfo}
                      </span>
                    </div>
                    {filter.map(
                      ({ icon, name, amount, checkbox, backgroundColor }) => (
                        <div
                          className="d-flex justify-content-between align-items-center p-1 px-2"
                          style={{ background: backgroundColor }}
                        >
                          <div className="d-flex gap-2 align-items-center">
                            <Checkbox
                              colorPrimary={checkbox.color}
                              colorTick={checkbox.colorTick}
                              defaultChecked={checkbox.check}
                            />
                            {icon}
                            <span
                              className={`fs12px fw-medium ${
                                key === 2 ? "text-black" : "text-white"
                              } `}
                            >
                              {name}
                            </span>
                          </div>

                          <span
                            className={`fs12px fw-medium ${
                              key === 2 ? "text-black" : "text-white"
                            } `}
                          >
                            {amount}
                          </span>
                        </div>
                      )
                    )}
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="fs14px fw-semibold">{total}</span>
                      <span
                        className={`fw-semibold fs14px  ${
                          key === 2 && "text-danger"
                        }`}
                      >
                        {totalAmount}
                      </span>
                    </div>
                  </div>
                )
              )}

              <div className="d-flex flex-column  gap-1 p-3 px-4">
                <div className="d-flex justify-content-between align-items-center">
                  <span className="fs14px fw-bold">Subtotal</span>
                  <span className="fs14px fw-semibold text-danger">$300</span>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <span className="fs14px fw-semibold">Net Savings</span>
                  <span className="fs14px fw-semibold text-danger">$100</span>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <span className="fs14px fw-semibold">Saving/Debit</span>
                  <span className="fs14px fw-semibold text-danger">$100</span>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <span className="fs14px fw-semibold">
                    Closing balance for this month
                  </span>
                  <span className="fs14px fw-semibold text-danger">$100</span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-8 ">
            <div className="d-flex align-items-center justify-content-center h-100">
              <span className="fs-3">Calendar Here</span>
            </div>
          </div>
        </div>
      </ManageMySpending>
    </>
  );
};

export default MyBills;
